
// ********* Import CSS ***************** //

import '@styles/main.scss';
import "./student-websites.css";

// ********* Import Images ***************** //

// ** GCS Wordmark ** //
// import "/src/assets/logos/gcs-wordmark-code-pink.png";

// ** Icons ** //
// import "/src/assets/icons/finger-tap-icon-white.png";
// import "/src/assets/icons/arrow.svg";

// ** Student Photo Grid ** //
// import "/src/assets/students-coding/gabby-website-colors-WC2023.jpeg";

// ** Lawson's Artwork ** //
import "/src/assets/summer-camp-2023/lawson-gcs-1.jpg";
import "/src/assets/summer-camp-2023/lawson-gcs-2.jpg";
import "/src/assets/summer-camp-2023/lawson-gcs-3.jpg";

// ** Nara's Photos ** //
import "/src/assets/student-created-images/nara/nara-flower.jpg";
import "/src/assets/student-created-images/nara/nara-sunset-1.jpg";
import "/src/assets/student-created-images/nara/nara-sunset-2.jpg";
import "/src/assets/student-created-images/nara/nara-sunset-3.jpg";
import "/src/assets/student-created-images/nara/nara-sunset-4.jpg";
import "/src/assets/student-created-images/nara/nara-wing-1.jpg";
import "/src/assets/student-created-images/nara/nara-wing-2.jpg";

// *********** Add Top Nav & Footer ***************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// ************ Add JS for Email Signup & Error Popup *************** //

import '/src/nav-header-footer/email-contact-new-classes.js';

// ********* Encouraging Words Popup *************** //

import '/src/popups/enc-words-popup/enc-words-popup.js';

// ********* States & Countries List *************** //

import '/src/form-lists/state-country-list.js';

// **************************** Loading Spinner ****************************** //

$(window).on('load', function(){
  document.getElementById("preloader").style.display = "block";
  setTimeout(removeLoadingSpinner, 600);
});

function removeLoadingSpinner(){
  $( "#preloader" ).fadeOut(100, function() {
    $( "#preloader" ).remove();
  });
}

// ********** Returning, Beginner, & Community Filtering ********** //

const returning = document.getElementById("returning");
const beginner = document.getElementById("beginner");
const support = document.getElementById("support");

const filterButtons = document.querySelectorAll(".website-filter-btn");

filterButtons.forEach((button) => {

  button.addEventListener("click", () => {

    console.log("Filter button clicked");

    filterButtons.forEach((btn) => {
      btn.classList.remove("active");
    });

    button.classList.add("active");

    const filterValue = button.dataset.filter;

    console.log("Filter Value: ", filterValue);

    if (filterValue == "beginner") {
      beginner.classList.remove("hidden");
      returning.classList.add("hidden");
      support.classList.add("hidden");

    } else if (filterValue == "returning") {
      returning.classList.remove("hidden");
      beginner.classList.add("hidden");
      support.classList.add("hidden");
    
    } else if (filterValue == "support") {
      support.classList.remove("hidden");
      beginner.classList.add("hidden");
      returning.classList.add("hidden");
    }

  });

});


// ****************************** JS for Rotating Quotes ****************************** //

(function() {
    // Array of quotes, where each item is an object with 'quote' and 'author' keys
    const quotes = [
        {
            quote: "These are amazing websites! Very colorful and I love the pictures. Great work… keep learning and making (and breaking) things &#128640;",
            author: "Rohan Aletty",
            title: "Engineer",
            org: "Spotify",
            location: "New York, NY"
        },
        {
            quote: "Holy camole you all are so talented. I loved seeing your unique photos and designs. And more important love seeing the promise you hold in creating a better world through the art and science of coding!!!!",
            author: "Kate Parker-Reilly",
            title: "Girl Cheer Leader",
            org: "",
            location: "Southington, CT"
        },
        {
            quote: "These sites are amazing! If you can code, you can do anything you want in the future! Keep it up!",
            author: "Danny D.",
            title: "",
            org: "",
            location: "Asheville, NC"
        },
        {
            quote: "I love this coding camp so much!! The teachers are so nice, and I love learning how to code!",
            author: "Zoe C.",
            title: "Student",
            org: "Girls Code Savannah",
            location: "Savannah, GA"
        },
        {
            quote: "So impressed with these websites! You girls are very talented.",
            author: "Julie Alvin",
            title: "SVP of Content",
            org: "The Skimm",
            location: "Detroit, MI"
        },
        {
            quote: "Congratulations on a job well done! I loved visiting the last day of camp to see the amazing websites you've all built. You are capable of this and so much more! Reach for the stars!",
            author: "Lisa Kanda",
            title: "CEO",
            org: "Elkay Advisors LLC",
            location: "Savannah, GA"
        },
        {
            quote: "You are all smart and inspiring. You are doing great! Keep on learning and creating. Cheers to you all from Switzerland!",
            author: "Karl Straub",
            title: "Girls Code Savannah Supporter",
            org: "karlstraub.com",
            location: "Zürich, Switzerland"
        },
        {
            quote: "Ladies, I am so proud of the work that you are doing. The websites look amazing, and I look forward to seeing the completed projects. Keep shining! You all are the bright future of STEM.",
            author: "Sabrina Walthall",
            title: "Professor of Science",
            org: "Mercer University",
            location: "Macon, GA"
        },
        {
            quote: "The creativity, enthusiasm and skill I’ve seen here are amazing. Remain boundless as you learn and apply these great techniques.",
            author: "Rex Belgarde",
            title: "Raving Girls Code Savannah Fan",
            org: "myLaurel",
            location: "Brooklyn, NY"
        },
        {
            quote: "It's so great to see the websites created by these amazing young women. Keep up the great work!",
            author: "Veronika Sonsev",
            title: "Co-Founder",
            org: "CommerceNext",
            location: "Miami, FL"
        },
        {
            quote: "I'm so impressed by these websites! What a gift to learn these amazing skills early in life! I hope my daughters (age 4 & 9 months) can do this when they are your age. Keep it up!! Sending love from New York. &#10084;",
            author: "Alicia Ortiz",
            title: "Aspiring Girl Coder",
            org: "Duet Health",
            location: "Smithtown, NY"
        },
        {
            quote: "Each of your websites are a testament to your skill & creativity! Keep up your dedication, no matter the challenges you face, and continue on to change the world through code!",
            author: "Jay Srivastava",
            title: "Girls Code Savannah Supporter",
            org: "Evergreen Nephrology",
            location: "Washington, DC"
        },
        {
            quote: "This is amazing. Everyone one of you are amazing. Keep learning keep growing. Great things are in y’alls future.",
            author: "Mike Morgan",
            title: "CEO",
            org: "BluWorkz",
            location: "Savannah, GA"
        },
        {
            quote: "You all have put in so much work to build really cool websites! I love the colors, animations, and pictures. Great work!",
            author: "Shoshana Wirth",
            title: "",
            org: "",
            location: "Easthampton, MA"
        },
        {
            quote: "These websites are so incredible. Blown away by the skill and determination of these early markers. Keep at it, we need more women in tech!",
            author: "Charlotte Christopher",
            title: "Product Manager",
            org: "Compass Pathways",
            location: "New York, NY"
        },
        {
            quote: "I'm so proud of you!" + "<br>" + "Keep going!",
            author: "Lesli Ott",
            title: "Executive Director",
            org: "Girls Code Savannah",
            location: "Savannah, GA"
        },
        {
            quote: "It's incredible that you made these fantastic websites from scratch! Knowing how to code is such a wonderful skill - you can build so many things. I'm excited for your bright futures!",
            author: "Jennifer Crews",
            title: "Managing Partner",
            org: "Pearl Partners",
            location: "Lenox, MA"
        },
        {
            quote: "It is so awesome to see how hard everyone has worked and how great your results are! So proud of you!",
            author: "Abbegayle Stallons",
            title: "Social Media Manager",
            org: "UP Market Media",
            location: "Savannah, GA"
        },
        {
            quote: "Fantastic websites, great techniques with the circular galleries, the layouts, and flow. Great job, can’t wait to see what is next.",
            author: "Hannah Dwyer",
            title: "Pharma Sector Capital Portfolio Lead",
            org: "Arcadis",
            location: "Kelsey, CA"
        },
        {
            quote: "Amazing Job!!!" + "<br>" + "Keep up the good work!",
            author: "Carleysue Mayes",
            title: "Lead Instructor",
            org: "Girls Code Savannah",
            location: "Savannah, GA"
        },
        {
            quote: "This is so awesome to see. Great work, and I hope my daughters follow in your path.",
            author: "Jason Stone",
            title: "Principal - Customer Solutions",
            org: "Amazon Web Services",
            location: "Minneapolis, MN"
        },
        {
            quote: "Amazing work, ladies! Coding your first website is no easy feat. Congratulations and keep up the good work!",
            author: "Kait Lance",
            title: "",
            org: "",
            location: "Savannah, GA"
        },
        {
            quote: "Fantastic work, ladies!!" + "<br>" + "I wish I had skills like this at your age!!",
            author: "Marcus Young",
            title: "Director",
            org: "DSS LLC",
            location: "Savannah, GA"
        },
        {
            quote: "All the websites look beautiful - I love the colors, emojis, and other creative choices.",
            author: "James GaNun",
            title: "",
            org: "",
            location: "Savannah, GA"
        },
        {
            quote: "I'm really proud of what you all have learned and accomplished in such a short amount of time. You guys should be too. Miss y'all and keep coding!! :)",
            author: "Sheila Nguyen",
            title: "Lead Instructor",
            org: "Girls Code Savannah",
            location: "Savannah, GA"
        },
        {
            quote: "Well done, ladies! I'm keeping an eye on what's developing here and looking forward to what's next!",
            author: "Malissa MacKay",
            title: "Sr Manager",
            org: "GA Dept Economic Development",
            location: "Savannah, GA"
        },
        {
            quote: "Congratulations girls on your websites. You are doing a great job!!! So proud of all of your hard work!! Keep up the work!!!",
            author: "Laraine Wright",
            title: "Proud Grandmother",
            org: "",
            location: "Savannah, GA"
        },
        {
            quote: "Everyone did so well. It is so impressive how many things you all did to your websites. Keep up the good work. ;)",
            author: "Meaghan C.",
            title: "Student",
            org: "Savannah Public School",
            location: "Savannah, GA"
        },

    ];

    const quoteSlides = document.querySelectorAll('.quote-slide');

    const quoteText = document.getElementById('quote-text');
    const quoteAuthor = document.getElementById('quote-author');
    const authorTitle = document.getElementById('author-title');
    const authorOrg = document.getElementById('author-org');
    const authorLocation = document.getElementById('author-location');

    const prevBtn = document.getElementById('quotePrevBtn');
    const nextBtn = document.getElementById('quoteNextBtn');

    let currentIndex = 0;
    let intervalId = null;
    const intervalTime = 8000; // Rotate the quotes every 8 seconds (8000 milliseconds)

    const smMediaQuery = window.matchMedia('(max-width: 460px)');


    function displayQuote() {

        const currentQuote = quotes[currentIndex];

        quoteText.innerHTML = `"${currentQuote.quote}"`;

        quoteAuthor.innerHTML = `\u2014 ${currentQuote.author}`;



        if (smMediaQuery.matches) {

            if (currentQuote.title.length !=0) {
                authorTitle.innerHTML = `${currentQuote.title}`;
            } else {
                authorTitle.innerHTML = 'Supporter';
            }

            if (currentQuote.org.length !=0) {
                authorOrg.innerHTML = `${currentQuote.org}`;
            } else {
                authorOrg.innerHTML = 'Girls Code Savannah';
            }

        } else {

            authorOrg.style.display = "none";

            if (currentQuote.title.length !=0 && currentQuote.org.length !=0) {
                authorTitle.innerHTML = `${currentQuote.title},` + " " + `${currentQuote.org}`;
            } else if (currentQuote.title.length !=0 && currentQuote.org.length == 0) {
                authorTitle.innerHTML = `${currentQuote.title}`;
            } else {
                authorTitle.innerHTML = 'Girls Code Savannah Supporter';
            }
        }

        authorLocation.innerHTML = `${currentQuote.location}`;     
    }

    // Go to the next quote
    function nextQuote() {
      currentIndex = (currentIndex + 1) % quotes.length;
      displayQuote();
    }

    // Go to the previous quote
    function prevQuote() {
      currentIndex = (currentIndex - 1 + quotes.length) % quotes.length;
      displayQuote();
    }

    // Start automatic rotation
    function startTimer() {
      intervalId = setInterval(nextQuote, intervalTime);
    }

    // Stop automatic rotation
    function stopTimer() {
      clearInterval(intervalId);
    }

    // Event Listeners for buttons
    nextBtn.addEventListener('click', () => {
      stopTimer();
      nextQuote();
      startTimer(); // Restart timer so it doesn't immediately rotate again
    });

    prevBtn.addEventListener('click', () => {
      stopTimer();
      prevQuote();
      startTimer();
    });

     // Display the first quote immediately on page load
    displayQuote();
    startTimer();
})();

